module.exports = __webpack_public_path__ + "static/media/documents.ac8ed8bf.png";